import React from 'react';

import { Box, Button, Divider, Stack } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import ReactHookFormSelect2 from 'common/components/form/ReactHookFormSelect2'; // Assuming it's in the same directory

import * as actions from '../actions';
import { getUsersOptions } from '../helpers';
import * as selectors from '../selectors';

const ReassignAdvisorForm = ({ filterData, initialValues, save, users }) => {
    const { t } = useTranslation();

    const { control, handleSubmit } = useForm({
        defaultValues: initialValues,
        mode: 'onChange',
    });

    const handleOnClickSave = (values) => save(filterData, values);

    // Assuming getUsersOptions returns an array of options with { label, value } structure
    const userOptions = [{ options: getUsersOptions(users) }];

    return (
        <Stack component="form" onSubmit={handleSubmit(handleOnClickSave)}>
            <ReactHookFormSelect2
                control={control}
                name="financial_advisor"
                options={userOptions}
                label={t('Financial advisor')}
            />

            <Divider sx={{ mx: (theme) => `${theme.spacing(-2)}!important` }} />

            <Box sx={{ textAlign: 'right' }}>
                <Button type="submit">{t('Save')}</Button>
            </Box>
        </Stack>
    );
};

const mapStateToProps = createStructuredSelector({
    initialValues: selectors.getInitialReassignAdvisorValues,
});

const mapDispatchToProps = (dispatch) => ({
    save: (filterData, values) =>
        dispatch(actions.bulkReassignAdvisor(filterData, values)),
});

ReassignAdvisorForm.propTypes = {
    filterData: PropTypes.object,
    initialValues: PropTypes.object,
    save: PropTypes.func,
    users: PropTypes.array,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ReassignAdvisorForm);
